import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductQuantityInputComponent } from "../product-quantity-input/product-quantity-input.component";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { ProductService } from "src/app/core/services/product-service";

@Component({
  selector: "app-product-image",
  templateUrl: "./product-image.component.html",
  styleUrls: ["./product-image.component.css"],
})
export class ProductImageComponent implements OnInit, OnDestroy {
  @Input()
  public product: any;

  @Input()
  public height: string;

  @Input()
  public produtoDescrHeight: string;

  /** Total no pedido (catálogo). Quando informado, o badge usa este valor em vez de `product.quantidade`. */
  @Input()
  public quantidadeCarrinho: number | null = null;

  @Output()
  public onAdd = new EventEmitter<number>();

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild("productQuantityInput", {
    read: ProductQuantityInputComponent,
    static: true,
  })
  public productQuantityInput!: ProductQuantityInputComponent;

  public API_IMAGENS: string;
  public API_IMAGENS_PRODUTOS: string;
  public site: ConfiguracoesSite;
  public rebate: number;

  private destroy$ = new Subject<void>();

  /** Quantidade exibida no selo sobre a imagem. */
  get quantidadeBadge(): number {
    if (this.quantidadeCarrinho != null && this.quantidadeCarrinho !== undefined) {
      const c = Number(this.quantidadeCarrinho);
      return Number.isFinite(c) && c > 0 ? c : 0;
    }
    const q = Number(this.product?.quantidade);
    return Number.isFinite(q) && q > 0 ? q : 0;
  }

  constructor(private router: Router, private productService: ProductService) {
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.site = Configuracoes.SITE;
  }

  ngOnInit(): void {
    this.rebate = this.product.desconto;
    this.productService.itemRemovedObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((id: number) => {
        if (id === this.product.id) {
          this.updateQuantity(0);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    if (this.productQuantityInput) {
      this.productQuantityInput.updateQuantity(quantity);
    }
  }
}
